__turbopack_context__.v({
  "enter": "Slide-module-scss-module__YfGwJq__enter",
  "fade-in": "Slide-module-scss-module__YfGwJq__fade-in",
  "idle": "Slide-module-scss-module__YfGwJq__idle",
  "no-transition": "Slide-module-scss-module__YfGwJq__no-transition",
  "slide": "Slide-module-scss-module__YfGwJq__slide",
  "slot-0": "Slide-module-scss-module__YfGwJq__slot-0",
  "slot-1": "Slide-module-scss-module__YfGwJq__slot-1",
  "slot-2": "Slide-module-scss-module__YfGwJq__slot-2",
  "slot-3": "Slide-module-scss-module__YfGwJq__slot-3",
  "slot-4": "Slide-module-scss-module__YfGwJq__slot-4",
});
